<template>
<div>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Appliances_breakdown') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('appliances_tooltip_breakdown')"></i>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" v-if="filtered_data.length /*&& total_consumption_kwh*/">
        <div v-show="filtered_data.length" class="row" style="border-bottom: 1px solid #ecedf0; padding-bottom: 10px; margin-bottom: 15px">
          <div class="col-1"></div>
          <div class="col-6">{{ $t('Appliance') }}</div>
          <div class="col-2"><span>{{ $t('Accumulated') }}</span></div>
          <div class="col-3"><span>{{ $t('Share') }}</span></div>
        </div>

        <div v-for="appliance in filtered_data"
        @click="select_appliance(appliance.group._id)" 
        :key="appliance.group._id" 
        class="row row-appliance align-items-center"
        :class="{ active: false }"
        style="cursor:pointer; padding-bottom:10px; border-bottom: 1px solid #ecedf0">
          <div class="col-1">
            <img style="height: 40px" :src="get_appliance_icon(appliance.device.appliance.type)">
          </div>
          <div class="col-6">{{ $t(appliance.device.appliance.type) }} ({{ $t(appliance.device.appliance.brand) }})</div>
          <div class="col-2">
            <span :style="{'color': '#f7882f'}" class="h4 mb-0 font-weight-bold">{{ friendlyFloatingPoint(appliance.data.energyUsed.Grid_House) }}</span>
            <span style="display:block">kWh</span>
          </div>
          <div class="col-3">
            <div class="progress">
              <div class="progress-bar" role="progressbar" :style="{width: Math.round((appliance.data.energyUsed.Grid_House*100) / total_consumption_kwh)+'%'}" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <span class="h5 mb-0 font-weight-bold">{{ Math.round((appliance.data.energyUsed.Grid_House*100) / total_consumption_kwh) || 0 }}%</span>
          </div>
        </div>

        <div v-show="filtered_data.length == data.length && data.length" class="row align-items-center">
          <div class="col-1"></div>
          <div class="col-6">Total</div>
          <div v-if="false" class="col-2">
            <span class="h3 mb-0 font-weight-bold text-orange">{{ friendlyFloatingPoint(total_consumption_w) }}</span>
            <span style="display:block">W</span>
          </div>
          <div class="col-2">
            <span class="h3 mb-0 font-weight-bold text-orange">{{ friendlyFloatingPoint(total_consumption_kwh) }}</span>
            <span style="display:block">kWh</span>
          </div>
          <div class="col-3"><span class="h3 mb-0 font-weight-bold">{{ total_consumption_kwh ? 100 : 0}}%</span></div>
        </div>
        
      </div>
      <div v-show="!loading && !filtered_data.length" v-else>{{ $t('No_Data') }}</div>
    </div>
  </div>

  <!-- The Modal -->
  <div class="modal" id="myModal">
    <div class="modal-dialog" style="min-width: 95vw">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">
            <span>{{ $t(selected_appliance.device.appliance.type) }} ({{ $t(selected_appliance.device.appliance.brand) }})</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <SummaryChart :total_data="total_data" :consumption_data="selected_appliance.data.summaryChart || []"></SummaryChart>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <div class="col-12 text-center">
            <button :disabled="!previous_appliance" type="button" @click="select_appliance(previous_appliance)" class="btn btn-primary mr-1">
              <i class="fas fa-chevron-left"></i>
              {{ $t('Previous') }}
            </button>
            <button :disabled="!next_appliance" type="button" @click="select_appliance(next_appliance)" class="btn btn-primary">
              {{ $t('Next') }}
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'
import SummaryChart from './SummaryChart.vue'
import friendlyFloatingPoint from '../helpers/friendlyFloatingPoint.js'
import appliance_icons from '../helpers/appliance_icons.json'

export default {
  name: 'AppliancesDecomposition',
  components: {
    LoadingSpinner,
    SummaryChart,
  },
  data() {
    return {
      chart: null,
      selected_appliance: { 
        device: { 
          appliance: {} 
        }, 
        group: {}, 
        data: {} 
      },
    }
  }, 
  mounted: function(){
    this.chart = null
    $('#myModal').on('hidden.bs.modal', function(){
      this.selected_appliance = { group: { _id: null }, data: {} }
    })
  },
  methods: {
    select_appliance: function(appliance_id){
      if (this.selected_appliance.group && this.selected_appliance.group.groupId == appliance_id) 
        this.selected_appliance = { group: {}, data: {} }
      else {
        this.selected_appliance = this.data.find(g => g.group._id == appliance_id)
        $("#myModal").modal('show')
      }
    },
    closeModal: function(){
      this.selected_appliance = { group: {}, data:{} }
    },
    friendlyFloatingPoint: function(n) {
      return friendlyFloatingPoint(n)
    },
    get_appliance_icon: function(appliance){
      return appliance_icons[appliance]
    }
  },
  computed: {
    data: function() {
      let data = this.$store.getters.data
      //data.sort((a,b) => b.data.energyUsed.consumed - a.data.energyUsed.consumed)
      data.sort((a,b) => {
        if (!b.data.energyUsed) b.data.energyUsed = { Grid_House: 0 }
        if (!a.data.energyUsed) a.data.energyUsed = { Grid_House: 0 }
        return b.data.energyUsed.Grid_House - a.data.energyUsed.Grid_House 
      })
      //console.log(data)
      return data 
    },
    previous_appliance: function(){
      if (!this.filtered_data.length || !this.selected_appliance.group._id) return null
      const current_pos = this.filtered_data.findIndex(a => a.group._id == this.selected_appliance.group._id)
      if (current_pos == 0) return null
      if (!this.filtered_data[current_pos - 1]) return null
      return this.filtered_data[current_pos - 1].group._id
    },
    next_appliance: function(){
      if (!this.filtered_data.length || !this.selected_appliance.group._id) return null
      const current_pos = this.filtered_data.findIndex(a => a.group._id == this.selected_appliance.group._id)
      if (current_pos+1 == this.filtered_data.length) return null
      return this.filtered_data[current_pos + 1].group._id
    },
    total_data: function(){
      return this.$store.getters.data_total_group.summaryChart
    },
    filtered_data: function(){
      if (!this.data.length) return []
      // let data_not_null = this.data.filter(d => d.data.energyUsed.consumed != null)
      let data_not_null = this.data.filter(d => d.data.energyUsed.Grid_House != null)
      if (data_not_null.length == 0) return []
      
      if (this.$store.getters.selected_groupId != "all") {
        let appliance = this.data.find(a => a.group._id == this.$store.getters.selected_groupId)
        if (appliance) return [appliance]
        else return []
      }  
      else return this.data
    },
    total_consumption_kwh: function(){
      let total = 0
      this.data.forEach(d => {
        //total += d.data.energyUsed.consumed
        let consumption = d.data.energyUsed ? d.data.energyUsed.Grid_House : 0
        total += consumption
      })
      return total
    },
    total_consumption_w: function(){
      let total = 0
      this.data.forEach(d => {
        total += d.current_values.consumption
      })
      return total
    },
    loading: function(){
      return this.$store.getters.data_loading
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}
.row-appliance:hover{
  background-color: lightgray;
}
.active {
  background-color: lightgray;
}
</style>
